export default {
  offlineContainer: {
    maxWidth: '500px',
    margin: '0 auto',
  },
};
